/**
 * Mobile nav drawer copy — single source: `src/data/nav-mobile-menu.json`.
 */
import navMobileMenuData from "@/data/nav-mobile-menu.json";
import { t } from "@/lib/content";
import type { Lang } from "@/lib/types";

type NavMobileMenuLocalizedString = Record<string, string>;

type NavMobileMenuData = {
  back: NavMobileMenuLocalizedString;
};

const menuData = navMobileMenuData as NavMobileMenuData;

export type NavMobileMenuCopy = {
  back: string;
};

export function getNavMobileMenuCopy(lang: Lang): NavMobileMenuCopy {
  return {
    back: t(menuData.back, lang),
  };
}
